import React from 'react'
import { getLoginInfo } from '../../../../configurations/auth/getLoginInfo'
import QRCode from 'react-qr-code'
import { DOCTOR_URL } from '../../../../configurations/initUrls'
import Dp from './../../../../components/app/users/Dp'

// A4 + margin none — print dialog isi ko default uthata hai
const A4_PRINT_CSS = `
  @page {
    size: A4 portrait;
    margin: 0 !important;
  }

  @media print {
    html, body {
      width: 210mm !important;
      margin: 0 !important;
      padding: 0 !important;
      background: #fff !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }

    .rx-a4-page {
      width: 210mm !important;
      height: 296.8mm !important;
      margin: 0 !important;
      padding: 0 !important;
      overflow: hidden !important;
      box-sizing: border-box !important;
      page-break-after: always;
      break-after: page;
      page-break-inside: avoid;
      break-inside: avoid;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
    .rx-a4-page:last-child {
      page-break-after: auto;
      break-after: auto;
    }

    .rx-a4-page img,
    .rx-a4-page svg {
      display: block;
      max-width: 100% !important;
    }
  }
`

export const ProfilePrint = React.forwardRef((props, ref) => {
    const userData = getLoginInfo()

    return (
        <div ref={ref}>
            <style type="text/css">{A4_PRINT_CSS}</style>

            {userData &&
                <div
                    className='rx-a4-page bg-white'
                    style={{ width: "210mm", height: "296.8mm", overflow: "hidden", padding: "6mm", boxSizing: "border-box" }}
                >
                    {/* inner card — border safe zone ke andar, printer edge par cut nahi hoga */}
                    <div
                        className='h-full w-full p-6 border border-gray-700 bg-gradient-to-r from-blue-100 to-emerald-100 flex flex-col items-center justify-center'
                        style={{ WebkitPrintColorAdjust: "exact", printColorAdjust: "exact", boxSizing: "border-box" }}
                    >
                        <div className="w-full flex flex-col justify-between items-center gap-3">
                            <div>
                                <div className="flex-shrink-0">
                                    <Dp user={userData} height={"h-36"} width={"w-36"} isNewUser={true} />
                                </div>
                            </div>

                            <div className='w-full flex flex-col justify-center items-center'>
                                <h3 className="text-3xl font-semibold text-gray-800">
                                    Dr. {userData.fullName}
                                </h3>
                                <div>
                                    <h3 className="text-lg text-center">
                                        {userData.specialisation?.name} ({userData.specialisation?.shortName})
                                    </h3>
                                    <h3 className="text-lg text-center">
                                        {userData.degree}
                                    </h3>
                                </div>
                            </div>

                            <div className="flex flex-col items-center">
                                <div style={{ width: "60mm", height: "60mm" }}>
                                    <QRCode
                                        value={DOCTOR_URL + userData.doctorId}
                                        style={{ width: "100%", height: "100%" }}
                                    />
                                </div>
                                <p className="text-2xl text-gray-600 mt-1">scan to register appointment</p>
                                <p className="text-5xl text-gray-600 font-bold mt-3">नंबर लगाने के लिए स्कैन करें</p>
                            </div>

                            <div className='flex flex-col items-center'>
                                <span className='text-[12px]'>Powered By</span>
                                <img className="h-5 w-auto" src="/assets/images/logo.png" alt="logo" />
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
})